import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { makeObservable, action, observable } from 'mobx';
import 'Styles/commonComponents/FiltersPanel/FiltersSimplePanel.scss';
import CheckboxWithText from "Components/Common/CheckboxWithText";
import ClearableInput from "Components/Common/ClearableInput";
import ShowFiltersButton from "Components/Common/FiltersPanel/ShowFiltersButton";

class FiltersSimplePanel extends Component {
    constructor(props) {
        super(props);
    }

    IsFieldVisible(fieldName) {
        return this.props.visibleFiltersFieldNames.some(it => it == fieldName);
    }

    IsFieldEnabled(fieldName) {
        return this.props.disabledFiltersFieldNames == null || this.props.disabledFiltersFieldNames.some(it => it == fieldName) == false;
    }

    IsAnyFieldEnabled() {
        return this.props.visibleFiltersFieldNames.some(it => this.IsFieldEnabled(it));
    }

    render() {
        return (
            <div className={`FiltersSimplePanel ${this.props.className}`}>
                <div className="filters-controls-and-search-button">
                    {
                        this.IsFieldVisible("regNumAlias") == false ? "" : (
                            <div className={`filter-regnum ${this.IsFieldEnabled("regNumAlias") ? "" : "disabled"}`}>
                                <ClearableInput
                                    value={this.props.getFilters().regNumAlias}
                                    onChange={num => {
                                        this.props.getFilters().regNumAlias = num;
                                        this.props.getFiltersRender().regNumAlias = num;
                                    }}
                                    clear={() => {
                                        this.props.getFilters().regNumAlias = "";
                                        this.props.getFiltersRender().regNumAlias = "";
                                    }}
                                    placeholder='Введите рег. номер'
                                />
                            </div>
                        )}
                    <button
                        className={`search-button blue-button ${this.IsAnyFieldEnabled() ? "" : "disabled"}`}
                        onClick={() => this.props.search()}>
                        Искать
                    </button>
                    {
                        this.IsFieldVisible("matchWholeWord") == false ? "" : (
                            <CheckboxWithText
                                className={`${this.IsFieldEnabled("matchWholeWord") ? "" : "disabled"}`}
                                checked={this.props.getFilters().matchWholeWord}
                                onChange={(checked) => {
                                    this.props.getFilters().matchWholeWord = checked;
                                    this.props.getFiltersRender().matchWholeWord = checked;
                                }}
                                text="Строгое соответствие"
                            />
                        )
                    }
                    {
                        this.props.getAdditionalFiltersContols ? this.props.getAdditionalFiltersContols() : ""
                    }
                </div>
                <ShowFiltersButton
                    className={this.props.classNameButton}
                    showFullFilters={this.props.showFullFilters}
                    getFiltersRender={this.props.getFiltersRender}
                    getFilters={this.props.getFilters}
                    getSelectedFiltersCount={this.props.getSelectedFiltersCount}
                    clearFilters={this.props.clearFilters}
                />
            </div>
        );
    }
}

export default observer(FiltersSimplePanel);